import { selector, atom } from "recoil";
import { getFeature, getPosPage } from "../services/apiCalls";

export const featureRefresh = atom({
  key: "featureRefresh",
  default: ""
})

export const posRefresh = atom({
  key: "posRefresh",
  default: ""
})

export const featureAlert = atom({
  key: "featureAlert",
  default: false
})

export const featureResponse = atom({
  key: "featureResponse",
  default: {}
})

export const features = selector({
  key: "features",
  get: async ({ get }) => {
    try {
      const res = get(featureRefresh);
      console.log(res)
      const result = await getFeature();
      return result.data || [];
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return [];
    }
  }
});

export const posPage = selector({
  key: "posPage",
  get: async ({ get }) => {
    try {
      const res = get(posRefresh);
      console.log(res)
      const result = await getPosPage();
      return result || {};
    } catch (error) {
      console.error(`ERROR: \n${error}`);
      return {};
    }
  }
});